import React, { useState } from 'react';
import { Box, Button, Input, Dialog } from '@dingus/dingus-ui';
import { api } from '../services/api';

const style = {
  position: 'fixed',
  bottom: 24,
  right: 8,
  zIndex: 1300,
};

const modalStyle = {
  position: 'fixed',
  bottom: 80,
  right: 24,
  width: 340,
  bgcolor: 'background.paper',
  borderRadius: 2,
  boxShadow: 24,
  p: 3,
  zIndex: 1400,
};

export default function FeedbackButton() {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleOpen = () => {
    setOpen(true);
    setSuccess(false);
    setError('');
  };
  const handleClose = () => {
    setOpen(false);
    setMessage('');
    setSuccess(false);
    setError('');
  };

  const handleSend = async () => {
    if (!message.trim()) {
      setError('Por favor, escribe tu feedback.');
      return;
    }
    setLoading(true);
    setError('');
    try {
      await api.sendFeedback(message);
      setSuccess(true);
      setMessage('');
    } catch (e) {
      setError(e.message || 'Error al enviar feedback');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Box style={style}>
        <Dialog
          open={open}
          setOpen={setOpen}
          trigger={
            <Button
              onClick={handleOpen}
              style={{
                width: 48,
                height: 48,
                borderRadius: '50%',
                boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                opacity: 0.7,
                backgroundColor: '#eee',
                border: 'none',
                cursor: 'pointer',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '20px',
                transition: 'opacity 0.2s',
              }}
              onMouseEnter={(e) => {
                e.target.style.opacity = '1';
                e.target.style.backgroundColor = '#e0e0e0';
              }}
              onMouseLeave={(e) => {
                e.target.style.opacity = '0.7';
                e.target.style.backgroundColor = '#eee';
              }}
              aria-label="Enviar feedback"
            >
              💬
            </Button>
          }
          title="¿Tienes feedback?"
          description="Comparte tus comentarios y sugerencias"
        >
        {success ? (
          <Box style={{ textAlign: 'center', padding: '20px' }}>
            <div style={{ color: '#22c55e', fontSize: '18px', fontWeight: '500' }}>
              ¡Gracias por tu feedback!
            </div>
          </Box>
        ) : (
          <>
            <Box style={{ marginTop: '16px' }}>
              <Input
                label="Tu mensaje"
                value={message}
                onChange={e => setMessage(e.target.value)}
                placeholder="Escribe aquí tu feedback..."
                disabled={loading}
                multiline
                rows={4}
              />
              {error && (
                <div style={{ color: '#ef4444', marginTop: '8px', fontSize: '14px' }}>
                  {error}
                </div>
              )}
            </Box>
            <Box style={{ display: 'flex', gap: '8px', marginTop: '24px', justifyContent: 'flex-end' }}>
              <Button onClick={() => {
                setOpen(false);
                handleClose();
              }} disabled={loading} variant="soft">
                Cancelar
              </Button>
              <Button 
                variant="outline"
                onClick={handleSend} 
                disabled={loading}
              >
                {loading ? 'Enviando...' : 'Enviar'}
              </Button>
            </Box>
          </>
        )}
        </Dialog>
      </Box>
    </>
  );
} 